import type { AxiosInstance } from 'axios'

/* Types */
import {
  HttpStatusCode,
  NotFoundError,
  ServerError,
  Success,
} from '@/types/api/results'
import type { MainPageSEO } from '@/types/common'
import type { DailyStatisticFetch } from '@/types/dailyStatistics'
import type { MainPageNews, SlugNews } from '@/types/api/news'
import type { ConfidentialData } from '@/types/api/confidential'

export function createCommonService({
  axios,
  sentry,
  hostname,
}: {
  axios: AxiosInstance
  sentry: any
  hostname: string
}) {
  return {
    async fetchListNews(page: number, size: number) {
      try {
        const { data } = await axios.get<MainPageNews>(
          `https://api.${hostname}/v3/main_page/news/`,
          {
            params: { page, size },
          },
        )

        return new Success(data)
      } catch (error: any) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('fetchListNews. Страница не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('fetchListNews. Что-то пошло не так')
        }
      }
    },

    async fetchSlugNews(slug: string) {
      try {
        const { data } = await axios.get<SlugNews>(
          `https://api.${hostname}/v3/main_page/news/${slug}`,
        )

        return new Success(data)
      } catch (error: any) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('fetchSlugNews. Страница не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('fetchSlugNews. Что-то пошло не так')
        }
      }
    },

    async fetchDailyStatistics() {
      try {
        const { data } = await axios.get<DailyStatisticFetch>(
          `https://api.${hostname}/daily_statistics/`,
        )

        return new Success(data)
      } catch (error: any) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError(
              'fetchDailyStatistics. Страница не найдена',
            )
          default:
            sentry.captureException(error)
            return new ServerError('fetchDailyStatistics. Что-то пошло не так')
        }
      }
    },

    async fetchMainPageCeo() {
      try {
        const { data } = await axios.get<MainPageSEO>(
          `https://api.${hostname}/v3/main_page/seo/`,
        )

        return new Success(data)
      } catch (error: any) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('fetchMainPageCeo. Страница не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('fetchMainPageCeo. Что-то пошло не так')
        }
      }
    },

    async fetchFlatpageData(path: string, city: string) {
      try {
        const { data } = await axios.get<ConfidentialData>(
          `${city}/flatpages/`,
          {
            params: { url: path },
          },
        )

        return new Success(data)
      } catch (error: any) {
        sentry.captureException(error)
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('fetchFlatpageData. Страница не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('fetchFlatpageData. Что-то пошло не так')
        }
      }
    },
  }
}
